import { useEffect, useContext, useState } from "react";
import { ProfileContext } from "./contexts/profileContext";
import { useNavigate } from 'react-router-dom';
import { ErrorContext } from "./contexts/errorContext";
export default function Payment() {
    const navigate = useNavigate();
    const apiURL = process.env.REACT_APP_ENVIRONMENT === 'development' ? process.env.REACT_APP_DEV_API_URL : process.env.REACT_APP_PROD_API_URL;
    const { userProfile, updateProfile } = useContext(ProfileContext);
    const {showError} = useContext(ErrorContext);
    // paid, canceled, or null
    const [paymentStatus, setPaymentStatus] = useState(null);

    function pollPaymentStatus(maxPolls, currentPoll=1) {
        if (currentPoll > maxPolls) {
            return;
        }
        fetch(`${apiURL}/get-payment-status`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                googleID: userProfile.uid
            })
        })
        .then(response => response.json())
        .then(data => {
            if (data.status === 'paid') {
                localStorage.setItem('token', data.token);
                updateProfile({
                    ...userProfile,
                    isPaid: true,
                });
            } else {
                setTimeout(() => {
                    pollPaymentStatus(maxPolls, currentPoll+1);
                }, 5000);
            }
        })
        .catch((error) => {
            // There was an error updating your payment status. Please contact 
            setTimeout(() => {
                pollPaymentStatus(maxPolls, currentPoll+1);
            }, 5000);
        });
    }

    useEffect(() => {
        if (!userProfile) {
            return;
        }
        // Check to see if this is a redirect back from Checkout
        const query = new URLSearchParams(window.location.search);

        if (query.get("success")) {
            setPaymentStatus('paid');
            pollPaymentStatus(10);
        }
      }, [userProfile]);

    function checkout() {
        if (!userProfile) {
            return;
        }
        fetch(`${apiURL}/create-checkout-session`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                googleID: userProfile.uid
            })
        })
        .then(response => response.json())
        .then(data => {
            window.location=data.url;
        }).catch(function(error) {
            showError("There was an error creating a checkout session. Please try again later")
        });
    }

    return (
        <>
        {
            paymentStatus !== 'paid' ? ( 
                <section class="text-gray-600 body-font overflow-hidden">
                <div class="container px-5 py-24 mx-auto">
                    <div class="flex flex-col text-center w-full mb-10">
                    <h1 class="sm:text-4xl text-3xl font-medium title-font mb-2 text-gray-900">Pricing</h1>
                    <p class="lg:w-2/3 mx-auto leading-relaxed text-base text-gray-500">A one-time investment on yourself.</p>
                    </div>
                    <div class="flex flex-wrap -m-4">
                    <div class="p-4 xl:w-1/2 md:w-1/2 w-full">
                        <div class="h-full p-6 rounded-lg border-2 border-gray-300 flex flex-col relative overflow-hidden">
                        <h2 class="text-sm tracking-widest title-font mb-1 font-medium">BASIC</h2>
                        <h1 class="text-5xl text-gray-900 pb-4 mb-4 border-b border-gray-200 leading-none">Free</h1>
                        <p class="flex items-center text-gray-600 mb-2">
                            <span class="w-4 h-4 mr-2 inline-flex items-center justify-center bg-gray-400 text-white rounded-full flex-shrink-0">
                            <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" class="w-3 h-3" viewBox="0 0 24 24">
                                <path d="M20 6L9 17l-5-5"></path>
                            </svg>
                            </span>3 rounds of Lingologue practice
                        </p>
                        </div>
                    </div>
                    <div class="p-4 xl:w-1/2 md:w-1/2 w-full">
                        <div class="h-full p-6 rounded-lg border-2 border-blue-500 flex flex-col relative overflow-hidden">
                        <span class="bg-blue-500 text-white px-3 py-1 tracking-widest text-xs absolute right-0 top-0 rounded-bl">POPULAR</span>
                        <h2 class="text-sm tracking-widest title-font mb-1 font-medium">PRO</h2>
                        <h1 class="text-5xl text-gray-900 leading-none flex items-center pb-4 mb-4 border-b border-gray-200">
                            <span>$35</span>
                            <span class="text-lg ml-1 font-normal text-gray-500">once</span>
                        </h1>
                        <p class="flex items-center text-gray-600 mb-2">
                            <span class="w-4 h-4 mr-2 inline-flex items-center justify-center bg-gray-400 text-white rounded-full flex-shrink-0">
                            <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" class="w-3 h-3" viewBox="0 0 24 24">
                                <path d="M20 6L9 17l-5-5"></path>
                            </svg>
                            </span>Unlimited rounds of Lingologue practice
                        </p>
                        <p class="flex items-center text-gray-600 mb-2">
                            <span class="w-4 h-4 mr-2 inline-flex items-center justify-center bg-gray-400 text-white rounded-full flex-shrink-0">
                            <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" class="w-3 h-3" viewBox="0 0 24 24">
                                <path d="M20 6L9 17l-5-5"></path>
                            </svg>
                            </span>Access to all features, including future ones
                        </p>
                        <button class="flex items-center mt-auto text-white bg-blue-500 border-0 py-2 px-4 w-full focus:outline-none hover:bg-blue-600 rounded" onClick={checkout}>Checkout
                            <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4 ml-auto" viewBox="0 0 24 24">
                            <path d="M5 12h14M12 5l7 7-7 7"></path>
                            </svg>
                        </button>
                        <p class="text-xs text-gray-500 mt-3">The $35 lifetime deal is limited and will expire soon.</p>
                        </div>
                    </div>
                    </div>
                </div>
                </section>
            ) : (
                <section class="text-gray-600 body-font">
                <div class="container px-5 py-24 mx-auto">
                    <div class="xl:w-1/2 lg:w-3/4 w-full mx-auto text-center">
                    <h1 class="sm:text-4xl text-3xl font-medium title-font mb-2 text-gray-900">Thank You</h1>
                    <span class="inline-block h-1 w-10 rounded bg-blue-500 mt-8 mb-6"></span>

                    <p class="leading-relaxed text-lg">We are now updating your account payment status. If you do not have access to Pro within a minute, please email linden.wang04@gmail.com. Happy practicing!</p>
                    <button class="flex mx-auto mt-16 text-white bg-blue-500 border-0 py-2 px-8 focus:outline-none hover:bg-blue-600 rounded text-lg" onClick={() => navigate('/')}>Go Home</button>
                    </div>
                </div>
                </section>
            )
        }

        </>
        
    )
}